import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'
// import Home from '../views/Home.vue'


//导入
import 'nprogress/nprogress.css'


const routes = [
    {
        path: '/',
        name: 'Login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/doubleControlKaifa',
        name: 'doubleControlKaifa',
        component: () => import('../views/doubleControlKaifa.vue')
    },

    /**
     * 统一认证cas登录
     */
    {
        //path: '/login-cas/:module',
        path: '/login-cas',
        name: 'CasLogin',
        component: () => import('../views/CasLogin.vue'),
        meta: { title: 'cas登录' },
        hidden: true,
    },

    /**
     * 矿山单点登录
     */
    {
        //path: '/login-cas/:module',
        path: '/login-ticket',
        name: 'TicketLogin',
        component: () => import('../views/ticketLogin'),
        meta: { title: 'ticket登录' },
        hidden: true,
    },

    /**
     * 工贸企业端
     */
    {
        //path: '/login-cas/:module',
        path: '/login-gmTicket',
        name: 'gmTicketLogin2',
        component: () => import('../views/gmTicket'),
        meta: { title: 'ticket登录' },
        hidden: true,
    },

    /**
     * 工贸监管端
     */
    {
        path: '/loginJgdTicket',
        name: 'gmTicketLogin1',
        component: () => import('../views/jgdTicketLogin'),
        meta: { title: 'jgdTicket登录' },
        hidden: true,
    },

    /**
     * 硬石单点登录页面
     */
    {
        path: '/loginYSJgdTicket',
        name: 'loginYSJgdTicket',
        component: () => import('../views/jgdYSTicketLogin'),
        meta: { title: 'jgdTicket登录' },
        hidden: true,
    },

    /**
     * 危化单点登录页面
     */
    {
        path: '/loginWhTicket',
        name: 'loginWhTicket',
        component: () => import('../views/whTicketLogin'),
        meta: { title: '危化单点登陆' },
        hidden: true,
    },

    {
        path: '/GMYHJgdTicketLogin',
        name: 'GMYHJgdTicketLogin',
        component: () => import('../views/GMYHJgdTicketLogin.vue'),
        meta: { title: '登录' },
        hidden: true,
    },
    /**
     * 企业端-危化企业端table页：风险空间分布图/隐患督导/重大隐患判断知识库
     */
    {
        path: '/whDoubleControl',
        name: 'whDoubleControl',
        component: () => import('../views/trouble/whExternal/index.vue'),
        hidden: true,
    },
    /**
     * 企业端-矿山企业端table页：首页/安全风险分级/隐患排查治理
     */
    {
        path: '/DoubleControlNew',
        name: 'DoubleControlNew',
        component: () => import('../views/DoubleControlks'),
        hidden: true,
    },
    /**
     * 企业端-工贸企业端table页：首页/安全风险分级/隐患排查治理
     */
    {
        path: '/gmDoubleControl',
        name: 'gmDoubleControl',
        component: () => import('../views/DoubleControlgm'),
        hidden: true,
    },
    /**
     * 企业端-烟花企业端table页：首页/安全风险分级/隐患排查治理
     */
    {
        path: '/yhDoubleControlNew',
        name: 'yhDoubleControlNew',
        component: () => import('../views/DoubleControlyh'),
        hidden: true,
    },
    /**
     * 企业端-工贸/烟花平台统计（首页)
     */
    {
        path: '/gmYhExternal',
        name: '工贸烟花双控统计功能',
        component: () => import('../views/gmYhExternal.vue'),
        hidden: true,
    },
    /**
     * 企业端-工贸/烟花隐患排查治理菜单
     */
    {
        path: '/gmskYhpczl',
        name: '工贸双控隐患排查治理',
        component: () => import('../views/trouble/troubleshootingTask/index.vue'),
        hidden: true,
    },
    /**
     * 企业端-安全风险分级管控+分布图
     */
    {
        path: '/gmskDivideUnion',
        name: '矿山双控安全风险分级管控',
        component: () => import('../views/doub/divideUnion/index.vue'),
        hidden: true,
    },
    /**
     * 企业端-烟花安全风险分级管控
     */
    {
        path: '/yhskDivideUnion',
        name: '烟花双控安全风险分级管控',
        component: () => import('../views/doub/divideUnion/yhIndex.vue'),
        hidden: true,
    },
    /**
     * 企业端-工贸安全风险分级管控
     */
    {
        path: '/gmskDivideUnion1',
        name: '工贸双控安全风险分级管控',
        component: () => import('../views/doub/divideUnion/gmIndex.vue'),
        hidden: true,
    },
    /**
     * 监管端-重大事故隐患挂牌-工贸
     */
     {
        path: '/majorAccidentGm',
        name: '',
        component: () => import('@/views/trouble/majorAccidentManagement/listing_jgd_gm.vue'),
        hidden: true,
    },
    /**
     * 监管端-重大事故隐患挂牌-烟花
     */
     {
        path: '/majorAccidentYh',
        name: '',
        component: () => import('@/views/trouble/majorAccidentManagement/listing_jgd_yh.vue'),
        hidden: true,
    },
    /**
     * 监管端-重大事故隐患销号
     */
     {
        path: '/cancelAccount',
        name: '',
        component: () => import('@/views/trouble/majorAccidentManagement/cancelAccount.vue'),
        hidden: true,
    },
    /**
     * 企业端-重大事故隐患挂牌-工贸
     */
     {
        path: '/majorAccident',
        name: '',
        component: () => import('@/views/trouble/majorAccidentManagement/listing_qyd.vue'),
        hidden: true,
    },
    /**
     * 监管端-矿山建设情况（首页）
     */
    {
        path: '/tongji',
        name: '111',
        component: () => import('@/views/trouble/tongji/jsqk/index.vue'),
        hidden: true,
    },

    {
        path: '/home',
        name: '首页',
        meta:{
            title:"首页"
        },
        component: () => import('@/views/trouble/tongji/new/home/index.vue'),
        hidden: true,
    },
    {
        path: '/riskLevelControl',
        name: '风险分级管控',
        meta:{
            title:"风险分级管控"
        },
        component: () => import('@/views/trouble/tongji/new/riskLevelControl/index.vue'),
        hidden: true,
    },
    {
        path: '/hazardInspectionControl',
        // name: '隐患排查治理',
        meta:{
            // title:"隐患排查治理"
        },
        component: () => import('@/views/trouble/tongji/new/hazardInspectionControl/index.vue'),
        hidden: true,
    },
    {
        path: '/majorHazardInspection',
        name: '重大事故隐患专项检查',
        meta:{
            title:"重大事故隐患专项检查"
        },
        component: () => import('@/views/trouble/tongji/new/majorHazardInspection/index.vue'),
        hidden: true,
    },
    {
        path: '/riskEventDisposal',
        name: '风险事件处置',
        meta:{
            title:"风险事件处置"
        },
        component: () => import('@/views/trouble/tongji/new/riskEventDisposal/index.vue'),
        hidden: true,
    },
    {
        path: '/mineDetails',
        name: '矿山详情',
        meta:{
            title:"矿山详情"
        },
        component: () => import('@/views/trouble/tongji/new/mineDetails/index.vue'),
        hidden: true,
    },

    /**
     * 监管端-工贸建设情况（首页）
     */
    {
        path: '/gmtongji',
        name: '工贸统计',
        meta:{
            title:"建设情况"
        },
        component: () => import('@/views/trouble/tongji/jsqk/gmTongJi.vue'),
        hidden: true,
    },
    /**
     * 监管端-烟花建设情况（首页）
     */
    {
        path: '/yhtongji',
        name: '烟花统计',
        component: () => import('@/views/trouble/tongji/jsqk/yhTongJi.vue'),
        hidden: true,
    },
    /**
     * 监管端-危化建设情况（首页）
     */
    {
        path: '/whtongji',
        name: '危化统计',
        component: () => import('@/views/trouble/tongji/jsqk/whTongJi.vue'),
        hidden: true,
    },
    /**
     * 弃用  20240305
     */
    {
        path: '/tongjiListOne',
        name: '222',
        component: () => import('@/views/trouble/tongji/yhpczl/tongjiListOne.vue'),
        hidden: true,
    },
    /**
     * 监管端-烟花隐患排查治理
     */
    {
        path: '/tongjiListOneYh',
        name: '222Yh',
        meta:{
            title:"隐患排查治理"
        },
        component: () => import('@/views/trouble/tongji/yhpczl/yhListOne.vue'),
        hidden: true,
    },
    /**
     * 监管端-工贸隐患排查治理
     */
    {
        path: '/tongjiListOneGm',
        name: '222Gm',
        meta:{
            title:"隐患排查治理"
        },
        component: () => import('@/views/trouble/tongji/yhpczl/gmListOne.vue'),
        hidden: true,
    },
    /**
     * 监管端-矿山隐患排查治理 @/views/trouble/tongji/yhpczl/ksListOne.vue
     */
    {
        path: '/tongjiListOneKs',
        name: '222Ks',
        meta:{
            title:"隐患排查治理"
        },
        component: () => import('@/views/trouble/report/report.vue'),
        hidden: true,
    },
    {
        path: '/dddd',
        name: '222Ks',
        meta:{
            title:"隐患排查治理"
        },
        component: () => import('@/views/trouble/troubleRiskInvestigation/index.vue'),
        hidden: true,
    },
    /**
     * 监管端-矿山隐患排查治理报表
     */
     {
        path: '/ksReport',
        name: 'ksReport',
        meta:{
            title:"隐患排查治理报表"
        },
        component: () => import('@/views/trouble/report/report.vue'),
        hidden: true,
    },
    /**
     * 监管端-危化隐患排查治理
     */
     {
        path: '/tongjiListOneWh',
        name: '222Ws',
        meta:{
            title:"隐患排查治理"
        },
        component: () => import('@/views/trouble/tongji/yhpczl/whListOne.vue'),
        hidden: true,
    },
    /**
     * 监管端-工贸预警信息
     */
    {
        path: '/tongjiListTwo',
        name: '333',
        meta:{
            title:"预警信息"
        },
        component: () => import('@/views/trouble/tongji/yjxx/tongjiListTwo.vue'),
        hidden: true,
    },
    /**
     * 监管端-工贸预警信息下钻
     */
    {
        path: '/tongjiListTwoDetail',
        name: '444dasdsa',
        meta:{
            title:"预警信息"
        },
        component: () => import('@/views/trouble/tongji/yjxx/detailListTwo.vue'),
        hidden: true,
    },

    /**
     * 弃用
     */
    {
        path: '/tongjiListTwoGm',
        name: '333Gm',
        component: () => import('@/views/trouble/tongji/yjxx/gmyjxx/gmListTwo.vue'),
        hidden: true,
    },
    /**
     * 监管端-烟花预警信息
     */
    {
        path: '/tongjiListTwoYh',
        name: '333Yh',
        meta:{
            title:"预警信息"
        },
        component: () => import('@/views/trouble/tongji/yjxx/yhyjxx/yhListTwo.vue'),
        hidden: true,
    },
    /**
     * 监管端-矿山预警信息
     */
    {
        path: '/tongjiListTwoKs',
        name: '333Ks',
        meta:{
            title:"预警信息"
        },
        component: () => import('@/views/trouble/tongji/yjxx/ksyjxx/ksListTwo.vue'),
        hidden: true,
    },
    /**
     * 监管端-危化预警信息
     */
     {
        path: '/tongjiListTwoWh',
        name: '333Wh',
        meta:{
            title:"预警信息"
        },
        component: () => import('@/views/trouble/tongji/yjxx/whyjxx/whListTwo.vue'),
        hidden: true,
    },
    /**
     * 监管端-危化预警信息下钻
     */
     {
        path: '/tongjiListTwoWhDetail',
        name: '333Whffd',
        meta:{
            title:"预警信息"
        },
        component: () => import('@/views/trouble/tongji/yjxx/whyjxx/whListTwoDetail.vue'),
        hidden: true,
    },
    /**
     * 监管端-烟花/矿山预警信息下钻
     */
    {
        path: '/tongjiListTwoYhDetail',
        name: '333Yhffd',
        meta:{
            title:"预警信息"
        },
        component: () => import('@/views/trouble/tongji/yjxx/yhyjxx/yhListTwoDetail.vue'),
        hidden: true,
    },
    /**
     * 监管端-矿山规范文件管理
     */
    {
        path: '/ksKnowledgeBase',
        name: 'ksKnowledgeBase',
        meta:{
            title:"重大隐患判定知识库"
        },
        component: () => import('@/views/trouble/tongji/knowledgeBase/ksIndex.vue'),
        hidden: true,
    },
    /**
     * 监管端-工贸规范文件管理
     */
    {
        path: '/gmKnowledgeBase',
        name: 'gmKnowledgeBase',
        meta:{
            title:"重大隐患判定知识库"
        },
        component: () => import('@/views/trouble/tongji/knowledgeBase/gmIndex.vue'),
        hidden: true,
    },
    /**
     * 监管端-烟花规范文件管理
     */
    {
        path: '/yhKnowledgeBase',
        name: 'yhKnowledgeBase',
        meta:{
            title:"重大隐患判定知识库"
        },
        component: () => import('@/views/trouble/tongji/knowledgeBase/yhIndex.vue'),
        hidden: true,
    },
    /**
     * 监管端-危化规范文件管理
     */
     {
        path: '/whKnowledgeBase',
        name: 'whKnowledgeBase',
        meta:{
            title:"重大隐患判定知识库"
        },
        component: () => import('@/views/trouble/tongji/knowledgeBase/whIndex.vue'),
        hidden: true,
    },
    /**
     * 监管端-矿山风险分级管控
     */
    {
        path: '/ksriskManagement',
        name: 'ksriskManagement',
        meta:{
            title:"风险分级管控"
        },
        component: () => import('@/views/trouble/tongji/riskManagement/ksindex.vue'),
        hidden: true,
    },
    /**
     * 监管端-烟花风险分级管控
     */
    {
        path: '/yhriskManagement',
        name: 'yhriskManagement',
        meta:{
            title:"风险分级管控"
        },
        component: () => import('@/views/trouble/tongji/riskManagement/yhindex.vue'),
        hidden: true,
    },
     /**
     * 监管端-危化风险分级管控
     */
      {
        path: '/whriskManagement',
        name: 'whriskManagement',
        meta:{
            title:"风险分级管控"
        },
        component: () => import('@/views/trouble/tongji/riskManagement/whindex.vue'),
        hidden: true,
    },
    /**
     * 监管端-工贸风险分级管控
     */
    {
        path: '/gmriskManagement',
        name: 'gmriskManagement',
        meta:{
            title:"风险分级管控"
        },
        component: () => import('@/views/trouble/tongji/riskManagement/gmindex.vue'),
        hidden: true,
    },
    /**
     * 监管端-矿山运行情况
     */
    {
        path: '/ksoperationList',
        name: 'ksoperationList',
        meta:{
            title:"运行情况"
        },
        component: () => import('@/views/trouble/tongji/operation/ksoperation/operationList.vue'),
        hidden: true,
    },
    /**
     * 监管端-工贸运行情况
     */
    {
        path: '/gmoperationList',
        name: 'gmoperationList',
        meta:{
            title:"运行情况"
        },
        component: () => import('@/views/trouble/tongji/operation/gmoperation/operationList.vue'),
        hidden: true,
    },
    /**
     * 监管端-烟花运行情况
     */
    {
        path: '/yhoperationList',
        name: 'yhoperationList',
        meta:{
            title:"运行情况"
        },
        component: () => import('@/views/trouble/tongji/operation/yhoperation/operationList.vue'),
        hidden: true,
    },
    /**
     * 监管端-危化运行情况
     */
     {
        path: '/whoperationList',
        name: 'whoperationList',
        meta:{
            title:"运行情况"
        },
        component: () => import('@/views/trouble/tongji/operation/whoperation/operationList.vue'),
        hidden: true,
    },
    // {
    //     path: '/DoubleControlIndex',
    //     name: '工贸双控首页——平台统计',
    //     component: () => import('../components/DoubleControl/DoubleControlIndex.vue'),
    //     hidden: true,
    // },
    /**
     * 弃用
     */




    //提供给硬石的隐患治理任务界面
    {
        path: '/ysYhzlrw',
        name: '硬石隐患治理任务界面',
        component: () => import('../views/trouble/dangerRectification/dangerRectificationPlan.vue'),
        hidden: true,
    },


    {
        path: '/DoubleControl',
        name: 'DoubleControl',
        component: () => import('../views/DoubleControl.vue'),
        children: [
            {
                //
                path: '/DoubleControlIndex',
                component: () => import('../components/DoubleControl/DoubleControlIndex.vue'),
            },
            {
                //
                path: '/accessResult',
                component: () => import('../views/doub/access/index.vue'),
            },
            {
                //
                path: '/mainUnion',
                component: () => import('../views/doub/mainUnion/index.vue'),
            },
            {
                //
                meta:{
                    title:"安全分级管控"
                },
                path: '/divideUnion',
                // component: () => import('../views/doub/divideUnion/index.vue'),
                component: () => import('../views/doub/divideUnion/index_new.vue'),
            },
            {
                //
                path: '/controlLevel',
                component: () => import('../views/doub/control/index.vue'),
            },
            {
                //
                path: '/notice',
                component: () => import('../views/doub/notice/index.vue'),
            },

            {
                //车间信息
                path: '/WorkShop',
                component: () => import('../components/Factory/RegionalManagement/WorkShop.vue'),
            },
            {
                //罐区信息
                path: '/TankFarm',
                component: () => import('../components/Factory/RegionalManagement/TankFarm.vue'),
            },
            {
                //库区信息
                path: '/ReservoirArea',
                component: () => import('../components/Factory/RegionalManagement/ReservoirArea.vue'),
            },
            {
                //公用工程
                path: '/Utilities',
                component: () => import('../components/Factory/RegionalManagement/Utilities.vue'),
            },
            {
                //设备列表
                path: '/EquipmentList',
                component: () => import('../components/Factory/UnitManagement/EquipmentList.vue'),
            },
            {
                //设备类型
                path: '/EquType',
                component: () => import('../components/Factory/UnitManagement/EquType.vue'),
            },
            {
                //特种设备
                path: '/specialEquipment',
                component: () => import('../components/Factory/UnitManagement/specialEquipment.vue'),
            },
            {
                //储罐
                path: '/TankManagement',
                component: () => import('../components/Factory/UnitManagement/TankManagement.vue'),
            },
            {
                //仓库
                path: '/WarehouseManagement',
                component: () => import('../components/Factory/UnitManagement/WarehouseManagement.vue'),
            },

            {
                //人员基本信息页面
                path: '/personnelInformation',
                component: () => import('../components/AllElements/BasicData/personnelInformation.vue'),
            },
            {
                //组织架构图页面
                path: '/ArchitectureDiagram',
                component: () => import('../components/AllElements/BasicData/Organization/ArchitectureDiagram.vue'),
            },
            {
                //部门管理页面
                path: '/DepartmentManage',
                component: () => import('../components/AllElements/BasicData/Organization/DepartmentManagement.vue'),
            },
            {
                //部门岗位管理页面
                path: '/DepartPost',
                component: () => import('../components/AllElements/BasicData/Organization/DepartmentPost.vue'),
            },
            {
                //岗位管理页面
                path: '/PostManage',
                component: () => import('../components/AllElements/BasicData/Organization/PostManagement.vue'),
            },
            {
                //部门管理页面
                path: '/DepartmentManagement',
                component: () => import('../components/AllElements/BasicData/Organization/DepartmentManagement.vue'),
            },

            {
                //部门岗位管理页面
                path: '/DepartmentPost',
                component: () => import('../components/AllElements/BasicData/Organization/DepartmentPost.vue'),
            },
            {
                //岗位管理页面
                path: '/PostManagement',
                component: () => import('../components/AllElements/BasicData/Organization/PostManagement.vue'),
            },
            {
                //在用证书页面
                path: '/CertificateInUse',
                component: () => import('../components/AllElements/BasicData/PersonnelCertificate/CertificateInUse.vue'),
            },
            {
                //证书类型页面
                path: '/CertificateType',
                component: () => import('../components/AllElements/BasicData/PersonnelCertificate/CertificateType.vue'),
            },
            {
                //证书配置页面
                path: '/ConfigureCertificate',
                component: () => import('../components/AllElements/BasicData/PersonnelCertificate/ConfigureCertificate.vue'),
            },
            {
                //历史证书页面
                path: '/HistoryCertificate',
                component: () => import('../components/AllElements/BasicData/PersonnelCertificate/HistoryCertificate.vue'),
            },
            {
                //缺失证书页面
                path: '/MissingCertificate',
                component: () => import('../components/AllElements/BasicData/PersonnelCertificate/MissingCertificate.vue'),
            },
            {
                //超期证书页面
                path: '/OverdueCertificate',
                component: () => import('../components/AllElements/BasicData/PersonnelCertificate/OverdueCertificate.vue'),
            },
            {
                //岗位证书页面
                path: '/PostCertificate',
                component: () => import('../components/AllElements/BasicData/PersonnelCertificate/PostCertificate.vue'),
            },
            {
                //离职人员证书页面
                path: '/ResignationCertificate',
                component: () => import('../components/AllElements/BasicData/PersonnelCertificate/ResignationCertificate.vue'),
            },
            {
                //人员基本信息页面
                path: '/personnelInformation',
                component: () => import('../components/AllElements/BasicData/personnelInformation.vue'),
            },


            {
                path: '/rewardsPunishments',
                name: '奖惩',
                component: () => import('../views/trouble/rewardsPunishments/rewardsPunishments.vue')
            },
            {
                path: '/inspectionTask',
                name: '检查任务',
                component: () => import('../views/trouble/inspectionTask/inspectionTask.vue')
            },
            {
                path: '/yhpczl',
                name: '隐患检查任务',
                meta:{
                    title:"隐患排查治理"
                },
                component: () => import('../views/trouble/troubleshootingTask/index.vue')
            },
            {
                path: '/troubleshootingTask',
                component: () => import('../views/trouble/troubleshootingTask/troubleshootingTask.vue')
            },
                        {
                path: '/troubleshootingList',
                component: () => import('../views/trouble/troubleshootingTask/troubleshootingList.vue')
            },

            {
                path: '/dailyAudit',
                name: '日常排查审核',
                component: () => import('../views/trouble/HiddenDangerReview/dailyAudit.vue')
            },
            {
                path: '/safetyAudit',
                name: '安全检查审核',
                component: () => import('../views/trouble/HiddenDangerReview/safetyAudit.vue')
            },
            {
                path: '/photoAudit',
                name: '随手拍审核',
                component: () => import('../views/trouble/HiddenDangerReview/photoAudit.vue')
            },
            {
                path: '/troubleshootingTaskCopy',
                name: '排查任务列表上传',
                component: () => import('../views/trouble/troubleshootingTask/troubleshootingTask.vue')
            },
            {
                path: '/myTask',
                name: '我的排查任务',
                component: () => import('../views/trouble/myTask/myTask.vue')
            },
            {
                path: '/controlObject',
                name: '管控对象',
                component: () => import('../views/trouble/controlObject/controlObject.vue')
            },
            {
                path: '/unitManagement',
                name: '单元管理',
                component: () => import('../views/trouble/unitManagement/unitManagement.vue')
            },
            // {
            //     path: '/Checkpoint',
            //     name: '检查点管理',
            //     component: () => import('@/views/trouble/Checkpoint/Checkpoint.vue')
            // },
            {
                path: '/effectEvaluation',
                name: '效果评估',
                component: () => import('../views/trouble/effectEvaluation/effectEvaluation.vue')

            },
            {
                path: '/pcrw',
                name: '隐患排查任务',
                component: () => import('../views/trouble/checkPlan/pcrw.vue')
            },


            {
                path: '/bmyxqk',
                name: '部门运行情况',
                component: () => import('../views/risk/setupTeamsub/bmyxtj.vue')
            },
            {
                path: '/gkcs',
                name: '',
                component: () => import('../views/risk/controlMeasure/gkcs.vue')
            },
            {
                path: '/jcry',
                name: '',
                component: () => import('../views/risk/controlMeasure/jcry.vue')
            },

            {
                path: '/wdjcrw',
                name: '',
                component: () => import('../views/risk/controlMeasure/wdjcrw.vue')
            },

            {
                //人员基本信息页面
                path: '/personnelInfo',
                component: () => import('../components/AllElements/BasicData/personnelInformation.vue'),
            },
            // {
            //     path:'',
            //     name:'风险复评预警',
            //     component:()=>()=> import('../views/risk/.vue')
            // },

            {
                //部门管理页面
                path: '/DepartmentManage',
                component: () => import('../components/AllElements/BasicData/Organization/DepartmentManagement.vue'),
            },
            {
                //部门岗位管理页面
                path: '/DepartPost',
                component: () => import('../components/AllElements/BasicData/Organization/DepartmentPost.vue'),
            },
            {
                //岗位管理页面
                path: '/PostManage',
                component: () => import('../components/AllElements/BasicData/Organization/PostManagement.vue'),
            },
            {
                path: '/threeCard',
                name: '三卡',
                component: () => import('../views/risk/threeCard/index.vue')
            },

            {
                path: '/cardKnow',
                name: '岗位风险应知卡',
                component: () => import('../views/risk/threeCard/cardKnow/index.vue')
            },

            {
                path: '/cardPromise',
                name: '安全承诺卡',
                component: () => import('../views/risk/threeCard/cardPromise/index.vue')
            },
            {
                path: '/cardManage',
                name: '应急处置卡',
                component: () => import('../views/risk/threeCard/cardManage/index.vue')
            },
            {
                path: '/checkStandard',
                name: '排查标准',
                component: () => import('../views/trouble/checkStandard/index.vue')
            },
            // {
            //     path:'',
            //     name:'排查表',
            //     component:()=>()=> import('../views/trouble/.vue')
            // },
            {
                path: '/checkPlan',
                name: '排查计划',
                component: () => import('../views/trouble/checkPlan/index.vue')
            },
            // {
            //     path:'',
            //     name:'排查任务',
            //     component:()=>()=> import('../views/trouble/.vue')
            // },
            {
                path: '/checkRecord',
                name: '排查记录',
                component: () => import('../views/trouble/checkRecord/index.vue')
            },
            // {
            //     path:'',
            //     name:'随手拍记录',
            //     component:()=>()=> import('../views/trouble/.vue')
            // },
            {
                path: '/troubleGovern',
                name: '隐患排查治理',
                component: () => import('../views/trouble/troubleGovern/index.vue')
            },
            {
                path: '/troubleList',
                name: '隐患清单',
                component: () => import('../views/trouble/troubleList/index.vue')
            },
            {
                path: '/troubleListVerify',
                name: '隐患审核',
                component: () => import('../views/trouble/troubleList/verify.vue')
            },
            {
                path: '/improve',
                name: '隐患治理记录',
                component: () => import('../views/trouble/improve/index.vue')
            },
            {
                path: '/dangerRectification',
                name: '整改记录',
                component: () => import('../views/trouble/dangerRectification/dangerRectification.vue')
            },
            {
                path: '/dangerRectificationPlan',
                name: '整改计划',
                component: () => import('../views/trouble/dangerRectification/dangerRectificationPlan.vue')
            },
            {
                path: '/rectificationInspection',
                name: '整改检查',
                component: () => import('../views/trouble/dangerAcceptance/rectificationInspection.vue')
            },
            {
                path: '/governanceList',
                name: '治理清单',
                component: () => import('../views/trouble/dangerAcceptance/governanceList.vue')
            },
            {
                path: '/checkReport',
                name: '排查报表',
                component: () => import('../views/trouble/reportForm/checkReport.vue')
            },
            {
                path: '/governmentReport',
                name: '治理报表',
                component: () => import('../views/trouble/reportForm/governmentReport.vue')
            },


            {
                path: '/checkTask',
                name: '排查任务',
                component: () => import('../views/trouble/checkTask/index.vue')
            },
            {
                path: '/indexCopy',
                name: '排查任务上传',
                component: () => import('../views/trouble/checkTask/indexCopy.vue')
            },
            {
                path: '/Checkpoint',
                name: '检查点管理',
                component: () => import('../views/trouble/Checkpoint/Checkpoint')
            },
            {
                path: '/checkList',
                name: '排查记录',
                component: () => import('../views/trouble/checkList/index.vue')
            },
            {
                path: '/improve',
                name: '整改信息',
                component: () => import('../views/trouble/improve/index.vue')
            },
            {
                path: '/troubleImproveList',
                name: '隐患治理清单',
                component: () => import('../views/trouble/troubleImproveList/index.vue')
            },
            {
                //制度文件
                path: '/rules',
                component: () => import('../components/AllElements/ManagementSystem/SafetyManagement.vue'),
                // component:  ()=> import('../views/risk/document/SafetyManagement.vue'),
            },
            {
                // 检查标准库
                path: '/checkStandard',
                component: () => import('../views/trouble/checkStandard/index.vue'),
            },
            {
                // 随手拍
                path: '/photo',
                component: () => import('../views/trouble/photo/index.vue'),
            },
            {
                // 检查计划
                path: '/checkPlan',
                component: () => import('../views/trouble/checkPlan/index.vue'),
            },
            {
                // 检查记录
                path: '/checkRecordSub',
                component: () => import('../views/trouble/checkRecordSub/index.vue'),
            },
            {
                // 检查隐患
                path: '/checkRecord',
                component: () => import('../views/trouble/checkRecord/index.vue'),
            },
            {
                // 专家检查
                path: '/expertCheck',
                component: () => import('../views/trouble/expertCheck/index.vue'),
            },
            {
                path: '/permission',
                name: '权限',
                component: () => import('../views/backManage/authority/permission/index.vue'),
            },
            {
                path: '/role',
                name: '角色',
                component: () => import('../views/backManage/authority/role/index.vue'),
            },
            {
                path: '/user',
                name: '用户',
                component: () => import('../views/backManage/authority/user/index.vue'),
            },
            {
                path: '/openAccount',
                name: '账户',
                component: () => import('../views/backManage/authority/openAccount/index.vue'),
            },
            {
                path: '/config',
                name: '系统配置',
                component: () => import('../views/backManage/config/index.vue'),
            },
            {
                path: '/bpmnConfig',
                name: '流程图配置',
                component: () => import('../views/backManage/bpmn/config.vue'),
            },
            {
                path: '/flowBpmnConfig',
                name: '流程图配置',
                component: () => import('../views/backManage/flow/config/index.vue'),
            },
            {
                path: '/flowMyTask',
                name: '我的任务',
                component: () => import('../views/backManage/flow/my/index.vue'),
            },
            {
                path: '/flowInstance',
                name: '流程发起',
                component: () => import('../views/backManage/flow/instance/index.vue'),
            },
        ]
    },

]


const router = createRouter({
    // mode: 'history',
    history: createWebHistory(),
    routes
})
router.afterEach((to, from) => {
    if(to.meta.title != null) {
        document.title = '' + to.meta.title;
    }
    else {
        document.title = '双重预防机制'
    }
})
// router.beforeEach((to, from, next) => {
//     NProgress.start()
//     next()
// })
//
// router.afterEach( {
//     NProgress.done()
// })

export default router
